import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useUserLibrary = (userId, queryParams) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken, apiVersion: "v2" });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const response = await instance.get(`users/${userId}/library`, {
			params: { ...params },
		});
		return response.data;
	};
	return useQuery(["user-library", userId, queryParams], () => fetch(), {
		...fetchConfig,
		enabled: !!userId,
	});
};

export default useUserLibrary;
